<div class="ag-cell-label-container ag-tooltip-trigger" role="presentation" [title]="displayName">
    <span #menuButton (click)="params.showColumnMenu(menuButton)" class="ag-header-icon ag-header-cell-menu-button"></span>
  
    <div class="ag-header-cell-label" role="presentation">
      <span class="ag-header-cell-text">{{ displayName }}</span>
  
      <span *ngIf="params.enableSorting" class="ag-header-icon ag-sort-order"></span>
      <span *ngIf="params.enableSorting" class="ag-header-icon ag-sort-ascending-icon"></span>
      <span *ngIf="params.enableSorting" class="ag-header-icon ag-sort-descending-icon"></span>
      <span *ngIf="params.enableSorting" class="ag-header-icon ag-sort-none-icon"></span>
  
      <span *ngIf="params.enableMenu" class="ag-header-icon ag-filter-icon"></span>
    </div>
  </div>
  